import React from "react";
import "./AdvanceFilterTag.scss";
import classNames from "classnames";
import { ReactComponent as CloseIcon } from "static/icons/cross-circle-gray.svg";
import { ReactComponent as SettingIcon } from "static/icons/settings-condition.svg";
import { ReactComponent as HiddenIcon } from "static/icons/hidden.svg";
import { ReactComponent as BrushIcon } from "static/icons/brush.svg";

const AdvanceFilterTag = ({
  metaData,
  isActive,
  isFilters,
  isColors,
  onClick,
  onRemoveHandler,
  label
}) => {

  const settingIconColor = isFilters ? "#3d7e99" : "#afb0b1";
  const colorIconColor = metaData.isPrimaryColor ? "#3d7e99" : "#afb0b1";

  const showHiddenIcon = metaData.isHiddenColumn
  const showColorIcon = isColors && !metaData.isHiddenColumn

  return (
    <div
      className={classNames("advance-tag", {
        "advance-tag--active": isActive,
      })}
    >
      <div className="advance-tag__close-icon" onClick={onRemoveHandler}>
        <CloseIcon />
      </div>
      <div onClick={onClick} className="advance-tag__name">
        {label}
      </div>
      <div className="advance-tag__icons-wrapper">
        {showHiddenIcon ? <HiddenIcon /> : null}
        {showColorIcon ? <BrushIcon color={colorIconColor} /> : null}
        <div className="advance-tag__setting-icon">
          <SettingIcon color={settingIconColor} onClick={onClick} />
        </div>
      </div>
    </div>
  );
};

export default AdvanceFilterTag;
